export default "<app-home>\n  <router-outlet></router-outlet>\n</app-home>\n<ngx-spinner></ngx-spinner>\n"